import React, { useEffect } from "react";
import BrandArea from "../components/BrandArea/BrandArea";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import EstimateArea from "../components/EstimateArea/EstimateArea";
import Layout from "../layouts/Layout";
import { gsapTitleAnimation } from "../lib/gsap-lib/gsapTitleAnimation";

const EstimatePage = () => {
  useEffect(() => {
    gsapTitleAnimation();
  }, []);

  return (
    <>
      <Layout>
        <BreadcrumbArea
          title={"Request & Estimate"}
          subtitle={"Request & Estimate"}
        />
        <EstimateArea />
      </Layout>
    </>
  );
};

export default EstimatePage;
